/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_ResumeInputs */

const en_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const de_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Anpassung`)
};

const fr_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const es_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const it_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const nl_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const pl_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const fi_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const da_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

const sv_landing_tab_resume = /** @type {(inputs: Landing_Tab_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailoring`)
};

/**
* | output |
* | --- |
* | "Resume tailoring" |
*
* @param {Landing_Tab_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_resume = /** @type {((inputs?: Landing_Tab_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_resume(inputs)
	if (locale === "fr") return fr_landing_tab_resume(inputs)
	if (locale === "es") return es_landing_tab_resume(inputs)
	if (locale === "it") return it_landing_tab_resume(inputs)
	if (locale === "nl") return nl_landing_tab_resume(inputs)
	if (locale === "pl") return pl_landing_tab_resume(inputs)
	if (locale === "fi") return fi_landing_tab_resume(inputs)
	if (locale === "da") return da_landing_tab_resume(inputs)
	if (locale === "sv") return sv_landing_tab_resume(inputs)
	return en_landing_tab_resume(inputs)
});